import { Block, Button,PrensaEngine, Typography } from '@xprog/prensa';
import React from 'react';

import { ClickableAssetProps } from './ClickableAsset.types';

const Image = PrensaEngine.styled('img', {});

const ClickableAsset: React.FC<ClickableAssetProps> = ({
  css,
  alt,
  height,
  href,
  id,
  src,
  target,
  width,
  hasH1,
}) => {
  const handleClick = () => {
    if (href) {
      window.location.assign(href)
    }
  };

  return (
    <Button
      id={id}
      onClick={handleClick}
      style={{border:'none',backgroundColor:'transparent'}}
    >
      <Block
        css={{
          height: height,
          width: width,
          ...css?.container,
        }}
      >
        {hasH1 && (
          <Typography as='h1'>
            <Image alt={alt} height={height} src={src} width={width} />
          </Typography>
        )}
        {!hasH1 && <Image alt={alt} height={height} src={src} width={width} />}
      </Block>
    </Button>
  );
};
export default ClickableAsset;
